require('./index.less');
var locale = require('./i18n');
var Row = require('./row.js');

Enhancer.registerWidget({
    construct: function(profile, zContext) {
        // profile = require('./profile-mock');
        var that = this;
        that.profile = profile;
        var $container = that.getContainer();
        $container.addClass('enhancer-grid-editor');
        that.$table = $('<table>').attr('cellspacing', 0)
            .addClass('ui-widget-content')
            .appendTo($container);
        that.rows = {};
        that.__constructHeader(profile);
        that.__constructBody(profile, zContext);

        var complete = function() {
            that.__constructOperationColum(profile);
            if (that.profile.showFooter) {
                that.$footer = $('<div>').addClass('footer ui-widget-content')
                    .data('rawContent', that.profile.footerContent)
                    .css('text-align', that.profile.footerContentAlign)
                    .appendTo($container);
                that.__updateFooter();
            }
            that.trig('complete');
        };
        if (profile.source) {
            that.__bindSourceData(profile.source, complete);
        } else {
            complete();
        }
        return $container;
    },
    __constructHeader: function(profile) {
        var that = this;
        that.$header = $('<thead>').appendTo(that.$table);
        var $tr = $('<tr>').appendTo(that.$header);
        if (profile.showRowIndex) {
            $tr.append('<th class="index ui-state-default"></th>');
        }
        var colModel = profile.colModel;
        for (var i in colModel) {
            $('<th>').addClass('ui-state-default')
                .width(colModel[i].width)
                .text(colModel[i].displayName || colModel[i].name)
                .appendTo($tr);
        }
    },
    __constructBody: function(profile, zContext) {
        var that = this;
        that.$table.find('tbody').remove();
        that.$tbody = $('<tbody>').appendTo(that.$table);
        var colModel = profile.colModel || [];

        for ( var i = 0; i < profile.rows; i++ ) {
            var rowId = that.getContainer().attr('id') + '-r' + i;
            var row = new Row(rowId, profile, that.$tbody, null, that, zContext);
            that.rows[rowId] = row;
        }
    },

    __bindSourceData: function(source, callback) {
        var that = this;
        that.getSourceData(source.id, {}, function(data) {
            var $tr = that.$tbody.find('tr');
            var rid, row;
            for ( var i = 0; i < data.length; i++) {
                if ($tr[i]) {
                    rid = $tr[i].id;
                } else {
                    rid = that.getContainer().attr('id')
                        + '-r' + new Date().getTime();

                    row = new Row(rid, 
                        that.profile, 
                        that.$tbody, 
                        null,
                        that,
                        that.zContext);
                    that.rows[rid] = row;
                }
                that.rows[rid].setData(data[i]);
            }
            callback();
        });
    },

    __constructOperationColum: function(prof) {
        if (!prof.addable && !prof.delable && !prof.sortable && !prof.copyable) {
            return;
        }
        var that = this;
        // var $optTd = that.$header.find('tr th.operation');
        // if ($optTd.length) {
        //     // Opeation column has existed.
        //     return;
        // }
        that.$header.find('tr').append('<th class="ui-state-default operation">'
                + '<i class="fa fa-wrench"></i>'
                + locale('operation') + '</th>');
        // that.$tbody.find('tr').append();
        
        that.$tbody.find('tr').each(function(index) {
            that.__appendOperations($(this), prof);
        });
    },
    __appendOperations: function($tr, profile) {
        var that = this;
        var $td = $('<td class="ui-state-default operation">').appendTo($tr);
        
        if (profile.addable) {
            $('<i class="fa fa-plus">')
                .on('click', function(e) {
                    if (that.__isFull()) {
                        return;
                    }
                    var rowId = that.getContainer().attr('id')
                        + '-r' + new Date().getTime();

                    that.rows[rowId] = new Row(
                        rowId, 
                        that.profile, 
                        that.$tbody, 
                        $(this).parent().parent(),
                        that,
                        that.zContext);
                    var $newTr = $(this).parent().parent().next();

                    that.__appendOperations($newTr, that.profile);
                    that.__indexChange();
                })
                .appendTo($td);
        }
        
        if (profile.delable) {
            $('<i class="fa fa-minus">')
                .on('click', function() {
                    if (that.__hasOnlyOneRow()) {
                        return;
                    }
                    var rid = $(this).parent().parent().attr('id');
                    that.rows[rid].destroy();
                    delete that.rows[rid];
                    that.__indexChange();
                })
                .appendTo($td);
        }

        if (profile.sortable) {
            // up
            $('<i class="fa fa-long-arrow-up">')
                .on('click', function() {
                    var $row = $(this).parent().parent();
                    if ($row.prev().length) {
                        $row.insertBefore($row.prev());
                    }
                    that.__indexChange();
                })
                .appendTo($td);

            // down
            $('<i class="fa fa-long-arrow-down">')
                .on('click', function() {
                    var $row = $(this).parent().parent();
                    if ($row.next().length) {
                        $row.insertAfter($row.next());
                    }
                    that.__indexChange();
                })
                .appendTo($td);
        }
    },
    __indexChange: function() {
        if (!this.profile.showRowIndex) {
            return;
        }
        this.$tbody.find('tr').each(function(index) {
            $(this).find('td:first').text(index + 1);
        });
    },
    getData: function() {
        var that = this;
        var rowsData = [];
        var dataMatrix = [];
        that.$tbody.find('tr').each(function() {
            var rid = $(this).attr('id');
            var arr = [];
            var rd = that.rows[rid].getData();
            rowsData.push(rd);
            for (var i in rd) {
                arr.push(rd[i]);
            }
            dataMatrix.push(arr);
        });
        var data = {};
        data.ROWS = rowsData;
        data.ROW_NUM = rowsData.length;
        data.MATRIX = dataMatrix;
        
        if (this.lastEventRow) {
            data.LAST_EVENT_ROW_ID = this.lastEventRow.getId();
            data.LAST_EVENT_ROW_INDEX = $('#' + data.LAST_EVENT_ROW_ID).index();
            var inp = this.lastEventRow.getLastEventInput();
            if (inp) {
                data.LAST_EVENT_INPUT_NAME = inp.getName();
                data.LAST_EVENT_INPUT_VALUE = inp.getTypedValue();
            }
        }
        return data;
    },
    isReady: function() {
        var isReady = true;
        for (var i in this.rows) {
            if (!this.rows[i].isReady()) {
                isReady = false;
            }
        }
        return isReady;
    },
    affected: function(zContext) {
        // if (!this.profile.source || !this.profile.source.params.length) {
            // Only need to affect the last event row for variable value binding.
            if (this.lastEventRow) {
                this.lastEventRow.affected(zContext);
            }
            return;
        // }
        this.__updateFooter();
        // var that = this;
        // that.$tbody.html('');
        // that.rows = {};
        // that.__bindSourceData(that.profile.source, function() {
        //     that.__constructOperationColum(that.profile);
        //     that.__updateFooter();
        // });
    },
    __hasOnlyOneRow: function() {
        var cnt = 0;
        for (var i in this.rows) {
            if (cnt === 0) {
                cnt = 1;
            } else if (cnt === 1) {
                return false;
            }
        }
        return true;
    },
    __isFull: function() {
        if (!this.profile.maxRows) {
            return false;
        }
        return this.__countRows() >= this.profile.maxRows;
    },
    __countRows: function() {
        var cnt = 0;
        for (var i in this.rows) {
            cnt++;
        }
        return cnt;
    },
    __updateFooter: function() {
        if (!this.$footer) {
            return;
        }
        var content = this.$footer.data('rawContent') || '';

        if (!content) {
            return;
        }
        var rows = this.getData()['ROWS'];

        // Calculate sum
        content = content.replace(/SUM\(\s?(\w+)\s?\)/ig, function(s, $1) {
            var sum = 0;
            var name = $1.toUpperCase();
            for (var i = 0; i < rows.length; i++) {
                sum += parseFloat(rows[i][name]) || 0
            }
            return sum;
        });

        // Calculate AVG
        content = content.replace(/AVG\(\s?(\w+)\s?\)/ig, function(s, $1) {
            if (!rows.length) {
                return '';
            }
            var sum = 0;
            var name = $1.toUpperCase();
            for (var i = 0; i < rows.length; i++) {
                sum += parseFloat(rows[i][name]) || 0
            }
            return sum / rows.length;
        });

        this.$footer.html(content);

    },
    trigRowEvent: function(eventName, srcRow) {
        this.lastEventRow = srcRow;
        this.trig( eventName );
        if (eventName === 'rowChange') {
            this.__updateFooter();
        }
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/index.js
 ** module id = 0
 ** module chunks = 0
 **/